import { mixed, object, string } from 'yup';
export const trackingLinkSchema = object({
    label: string().required(),
    type: string().oneOf(['url', 'email', 'phone']).required(),
    context: string().oneOf(['default', 'ios', 'android', 'desktop']).optional(),
    description: string().optional(),
    priceLabel: string().max(32).optional(),
    // imageFile is a local File picked in the showroom-mode form; the campaign
    // service strips it before JSON serialisation and re-attaches it as a
    // multipart field. yup just needs to allow it through.
    imageFile: mixed()
        .optional()
        .test('is-file', 'Must be a file', (v) => v === undefined || v instanceof File),
    targetUrl: string()
        .required()
        .test('matches-type', 'Invalid value for selected type', function (value) {
        const { type } = this.parent;
        if (!value)
            return false;
        switch (type) {
            case 'url':
                return /^https?:\/\/.+/i.test(value);
            case 'email':
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            case 'phone':
                return /^\d{8,10}$/.test(value);
            default:
                return false;
        }
    }),
});
